// Extract the YouTube video id from the common URL formats:
// watch?v=ID, youtu.be/ID, shorts/ID, embed/ID, live/ID.
export function youtubeId(url) {
  if (!url) return null;
  const str = String(url).trim();
  const patterns = [
    /(?:youtube\.com\/watch\?(?:.*&)?v=)([A-Za-z0-9_-]{11})/,
    /(?:youtu\.be\/)([A-Za-z0-9_-]{11})/,
    /(?:youtube\.com\/(?:embed|shorts|live|v)\/)([A-Za-z0-9_-]{11})/,
  ];
  for (const re of patterns) {
    const m = str.match(re);
    if (m) return m[1];
  }
  // Bare id
  if (/^[A-Za-z0-9_-]{11}$/.test(str)) return str;
  return null;
}

export function youtubeEmbedUrl(url) {
  const id = youtubeId(url);
  return id ? `https://www.youtube.com/embed/${id}` : null;
}
